module.exports = __webpack_public_path__ + "img/u23三人男篮初选.b4b62622.png";